/* eslint-disable no-nested-ternary */
/** @jsxImportSource @emotion/react */

import React, {useMemo} from 'react';

import {css} from '@emotion/react';
import PropTypes from 'prop-types';

import AddCircle from '@/assets/icons/AddCircle.svg';
import {fontSize, proteinConcentrationUnactiveColor, roundCorner} from '@/constants/appStyle';
import {FONT_SIZE as FontSize} from '@/constants/pcConstAppData';
import {WIFI_STRENGTH} from '@/contexts/WifiListContext';
import {useChangeWifiSettingContext, useWifiSettingContext} from '@/contexts/WifiSettingContext';

function WifiAddNetwork(props) {
  const {wifi, isSelected} = props;
  const {isConnecting} = useWifiSettingContext();
  const {SetSelectedWifi} = useChangeWifiSettingContext();

  const isConnectingWithCurrentWifi = useMemo(() => isConnecting && isConnecting.Name === wifi.Name, [isConnecting]);

  const wifiIcon = AddCircle;

  const WifiAddNetworkStyle = css({
    width: 'inherit',
    backgroundColor: 'white',
    fontSize: parseInt(window.localStorage.getItem(FontSize), 10) || fontSize,
    textAlign: 'left',
    padding: '10px',
    display: 'flex',
    border: isSelected ? `2px solid ${proteinConcentrationUnactiveColor}` : 'none',
    borderRadius: roundCorner,
  });

  const WifiNameStyle = css({
    paddingLeft: '12px',
    width: '100%',
    minWidth: '100px',
    justifyContent: 'flex-start',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  });

  const StatusStyle = css({
    width: '200px',
    color: !wifi.IsConnected && isConnectingWithCurrentWifi ? 'grey' : 'green',
  });

  // const WifiArroStyle = css({
  //   float: 'left',
  // });

  return (
    <div
      css={WifiAddNetworkStyle}
      onClick={() => SetSelectedWifi(wifi)}
    >
      <img
        src={wifiIcon}
        alt={wifiIcon}
      />
      <div css={WifiNameStyle}>Add Network</div>
      {!wifi.IsConnected && isConnectingWithCurrentWifi ? (
        <div css={StatusStyle}>Connecting...</div>
      ) : wifi.IsConnected && isConnecting === null ? (
        <div css={StatusStyle}>Connected</div>
      ) : (
        ''
      )}
    </div>
  );
}
WifiAddNetwork.propTypes = {
  isSelected: PropTypes.bool,
  wifi: PropTypes.shape({
    Name: PropTypes.string,
    Strength: PropTypes.oneOf([WIFI_STRENGTH.LOW, WIFI_STRENGTH.MEDIUM, WIFI_STRENGTH.STRONG]),
    IsConnected: PropTypes.bool,
  }),
};
WifiAddNetwork.defaultProps = {
  isSelected: false,
  wifi: {},
};
export default React.memo(WifiAddNetwork);
